/**
 *
 * ActionBar
 *
 */

import React, { memo } from 'react';
import DialogActions from '@mui/material/DialogActions';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
function ActionBar({ actions, onAccept, onClear, customAccept, customClear }) {
  return (
    <DialogActions sx={{ justifyContent: 'space-between' }}>
      {actions.includes('clear') && (
        <Button
          color="primary"
          size="small"
          variant="text"
          onClick={() => {
            onClear();
            customClear();
          }}
        >
          Clear
        </Button>
      )}

      {actions.includes('accept') && (
        <Button
          color="primary"
          size="small"
          variant="text"
          onClick={() => {
            onAccept();
            customAccept?.();
          }}
        >
          Save
        </Button>
      )}
    </DialogActions>
  );
}

ActionBar.propTypes = {
  actions: PropTypes.array,
  onAccept: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  customAccept: PropTypes.func,
  customClear: PropTypes.func.isRequired,
};

export default memo(ActionBar);
